import { INDEX_TICKER_TO_NAME } from '@mais-retorno-front/libs/util-benchmark-constants';

export const getBenchmarkNicename = (benchmark: string): string => {
  if (!benchmark) return '--';

  const nicename = INDEX_TICKER_TO_NAME[benchmark];

  return nicename || benchmark;
};
